import { render } from "./NewOrderWizard.vue?vue&type=template&id=3b0ed6a5&ts=true"
import script from "./NewOrderWizard.vue?vue&type=script&lang=ts"
export * from "./NewOrderWizard.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./NewOrderWizard.vue?vue&type=style&index=0&id=3b0ed6a5&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__